module.exports = __webpack_public_path__ + "img/mkv.0ca93647.svg";